import * as React from 'react';
import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { ComponentStoreHelpers, IOption } from './helpers/ComponentStoreHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import ReactHtmlParser from 'react-html-parser';
import { LabelAndPopover } from './components/label-and-popover';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { PollResult } from './components/poll-result';
import { PollResultsTotal } from './components/poll-results-total';

export interface RadioState {
    dataSourceCounter: number;
    timer: any;
    hasFocus: boolean;
}

class Radio extends React.Component<FormControlProps, RadioState> {
    constructor(props: FormControlProps) {
        super(props);
        this.state = {
            dataSourceCounter: 0,
            timer: undefined,
            hasFocus: false
        };    
    }

    componentDidMount() {
        if (ComponentStoreHelpers.hasDatasource(this)) {
            ComponentStoreHelpers.setFormFieldData(this, []);
            ComponentStoreHelpers.getData(this);
        }

        const value = this.props.field.value,
            formikBag = this.props.formikBag,
            formFieldDefinition = this.props.formFieldDefinition;
        
        if (value !== '') {
            formikBag.setFieldTouched(formFieldDefinition.name, true, true);
        }
    }

    unmounted : boolean = false;
    componentWillUnmount() {
        this.unmounted = true;
    }

    getCheckedState = (option : IOption, radioAsImageValue? : string) => {
        // checks op true/false ivm verschil hoe vanuit kentico-form (string) en 
        // api (boolean) data wordt aangeleverd
        if (radioAsImageValue && radioAsImageValue == this.props.field.value) {
            return true;
        }  
        
        let value = this.props.field.value;
        if (value && value.value) {
            value = value.value;
        }

        const result = ((value.toString() || "").trim() === (option.value.toString() || "").trim()) || 
            (option.value === "true" && !!value) || 
            (option.value === "false" && value === false) ||
            (option.value === "false" && value === "");

        return result;
    }

    onInputFocus = (event) => {                
        this.setState({hasFocus : true});
    }

    onInputBlur = (event) => {
        if (event.persist) {
            event.persist();
        }
        this.setState({hasFocus : false}, () => {
            this.props.field.onBlur(event);
        });
    }

    clickOuterRadioDiv = (radioButtonId, option : IOption) => {
        const radioButtonElement = document.getElementById(radioButtonId);
        if (radioButtonElement) {
            radioButtonElement.click();
        }
    }

    showPollResults = () => {
        const {isShowPollResults , pollResults} = this.props.formController.props;

        return !!isShowPollResults && pollResults &&
                    pollResults[this.props.formFieldDefinition.name];
    }

    render() {
        function getId(component: React.Component<FormControlProps>, option: IOption) {
            return `${component.props.formController.props.formCMSName || "form"}-${component.props.formFieldDefinition.name}-${option.value}`;
        }

        const fieldProperties = {
            ...FormControlHelpers.baseProperties(this),
            ...FormControlHelpers.onChangeSetValueViaEvent(this)
        };

        const inputDecorators = this.props.formFieldDefinition.inputcontrolstyle !== undefined ? (this.props.formFieldDefinition.inputcontrolstyle || "").toLowerCase().split(" ") : "";
        const isBlockMode = inputDecorators.indexOf("blocks") >= 0;

        const options = ComponentStoreHelpers.getListData(this);
        const disabled = this.props.formFieldDefinition.showAsDisabled || !!this.props.formFieldDefinition.readOnly;

        if (this.props.formFieldDefinition.subtype == "RadioButtonAsImageControl") {
            return (
                <div className={'form-group form-control__radio-button-as-image row ' + this.props.visibilityClass + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-radio-form-group'}>
                    <LabelAndPopover 
                        className="form__radio-label"
                        fieldId={PropertyHelpers.getFieldID(this.props)} 
                        label={FormLabelHelpers.getFieldLabel(this)}
                        explanation={this.props.formFieldDefinition.explanation}
                        hasPopover={this.props.formFieldDefinition.hasPopover}                    
                    ></LabelAndPopover>
                    <div className="form-control__radio-button-as-image-options-container">{options.map((option: IOption, index: number) => {

                        const splittedKeys = option.value.split('|');
                        const imageValue = splittedKeys.length > 1 ? splittedKeys[1] : "";

                        const isIcon = imageValue.indexOf("icon-") == 0;
                        const text = option.label ? option.label : option.value;

                        
                        return (
                            <div
                                key={getId(this, option)}
                                className={"custom-control custom-radio custom-control-inline " +
                                 "form-control__radio-button-as-image-option col-12 col-md-6 " +                                 
                                 (isIcon ? "form-control__radio-button-with-icon-option" : "")}
                            >
                                <input
                                    {...fieldProperties}
                                    className={FormStylingHelpers.getRadioStyle(this)}
                                    type="radio"
                                    checked={this.getCheckedState(option, imageValue)}
                                    ref={this.props.formFieldDefinition.name + index.toString()}
                                    id={getId(this, option)}
                                    value={option.value}
                                    disabled={disabled} 
                                    onFocus={this.onInputFocus}
                                    onBlur={this.onInputBlur}                                                   
                                />
                                <label htmlFor={getId(this, option)} 
                                    className={"custom-control-radio-button-image " + (isIcon ? "custom-control-radio-button-with-icon" : "")}>
                                    {isIcon ? <span className="custom-control-radio-button-icon">
                                                <span className={"icon " + imageValue}></span>
                                                <span className="custom-control-radio-button-icon-text">{text}</span>
                                            </span> :
                                        <img src={imageValue} alt={text} />
                                    }
                                </label>
                            </div>
                        );
                    })}
                    </div>
                    {!this.state.hasFocus && FormControlHelpers.invalidFeedbackComponent(this)}
                    {this.props.formFieldDefinition.explanation &&
                        <div className="form-group__explanation-text">{ReactHtmlParser(this.props.formFieldDefinition.explanation)}</div>
                    }
    
                </div>
            );
        }

        let additionalCssClass = '';
        if (this.props.formFieldDefinition.cssClass !== undefined) {
            additionalCssClass = this.props.formFieldDefinition.cssClass;
        }        

        return (
            <div className={additionalCssClass + ' form-group' + this.props.visibilityClass + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-radio-form-group'}>
                <LabelAndPopover 
                    className="form__radio-label"
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}                    
                ></LabelAndPopover>
                {options.map((option: IOption, index: number) => {

                    if (!!this.props.formController.props.isShowPollResults) {
                        return <PollResult 
                            key={getId(this, option)} 
                            label={option.label}
                            id={getId(this, option)} 
                            checked={this.getCheckedState(option)} 
                            pollResults={this.props.formController.props.pollResults && this.props.formController.props.pollResults[this.props.formFieldDefinition.name]}  
                        ></PollResult>;
                    }
                    let correctAnswerClass = "";
                    if (this.props.formFieldDefinition.correctAnswer !== undefined && 
                        this.props.formFieldDefinition.correctAnswer !== false &&
                        this.props.formFieldDefinition.correctAnswer !== "") {
                        if (option.value === this.props.formFieldDefinition.correctAnswer) {
                            if (this.getCheckedState(option)) {
                                correctAnswerClass = "form-control__radio-button-correct-selected";
                            } else {
                                if ((this.props.field.value.toString() || "").trim() != "") {
                                    correctAnswerClass = "form-control__radio-button-correct";
                                }
                            }
                        } else {
                            if (this.getCheckedState(option)) {
                                correctAnswerClass = "form-control__radio-button-incorrect";
                            }
                        }
                    }

                    return (
                        <div
                            key={getId(this, option)}
                            className={"custom-control custom-radio custom-control-inline " + 
                            correctAnswerClass + " " + 
                            (this.getCheckedState(option) ? "custom-radio-checked " : "" ) +
                            (!!isBlockMode ? "radio-button__block" : "")}
                            onClick={(event) => this.clickOuterRadioDiv(getId(this, option), option)}                            
                        >
                            <input
                                {...fieldProperties}
                                {...FormControlHelpers.onRadioButtonChangeSetValueViaEvent(this, option.label)}
                                className={FormStylingHelpers.getRadioStyle(this)}
                                type="radio"
                                checked={this.getCheckedState(option)}
                                ref={this.props.formFieldDefinition.name + index.toString()}
                                id={getId(this, option)}
                                value={option.value}
                                disabled={disabled}
                                onFocus={this.onInputFocus}
                                onBlur={this.onInputBlur}
                                onClick={fieldProperties.onChange}                                                         
                            />
                            <label htmlFor={getId(this, option)} className="custom-control-label">
                                {!!isBlockMode && option.icon && option.icon != "" && <span className={"icon icon-" + option.icon}></span>}
                                {ReactHtmlParser(option.label)}
                            </label>
                        </div>
                    );
                })}
                {!this.state.hasFocus && FormControlHelpers.invalidFeedbackComponent(this)}
                {this.showPollResults() && <>
                    <PollResultsTotal pollResults={this.props.formController.props.pollResults[this.props.formFieldDefinition.name]}></PollResultsTotal>
                </>}
            </div>
        );
    }
}

export { Radio };
